class Concellos extends Array {}

const concello_api_adapter = edar => {
    if (edar["geom"]) {
        edar["geom"]["crs"] = {
            type: "name",
            properties: {
                name: "urn:ogc:def:crs:EPSG::25829",
            },
        };
    }

    edar["created_at"] = new Date(edar["created_at"]);
    edar["updated_at"] = new Date(edar["updated_at"]);
    return edar;
};

const concellos_api_adapter = concellos => concellos.map(concello_api_adapter);

const createConcellos = (data = []) => {
    const concellos = Concellos.from(data, concello => createConcello(concello));
    return concellos;
};

const concello_view_adapter = concello => {
    delete concello["folder"];
    delete concello["featured_image"];
    delete concello["featured_document"];
    delete concello["created_at"];
    delete concello["created_by"];
    delete concello["updated_at"];
    delete concello["updated_by"];

    delete concello["stats"];

    return concello;
};

const createConcello = ({
    id = null,
    codigo = "",
    nome = "",
    folder = "",
    featured_image = "",
    featured_document = "",
    geom = null,
    poboacion_fixa = null,
    estacionalidade = null,
    factor_crecemento = null,
    stats = null,
    created_by = "",
    created_at = null,
    updated_by = "",
    updated_at = null,
} = {}) => {
    const publicApi = {
        id,
        codigo,
        nome,
        folder,
        featured_image,
        featured_document,
        geom,
        poboacion_fixa,
        estacionalidade,
        factor_crecemento,
        stats,
        created_by,
        created_at,
        updated_by,
        updated_at,
    };

    return Object.freeze(publicApi);
};

export {
    createConcello as default,
    createConcellos,
    concello_api_adapter,
    concellos_api_adapter,
    concello_view_adapter,
};
